import { setGA4Event } from "@bevco/Store/Handlers/Utilities/CustomTracking";
import { mediaQueriesBP } from "@bevco/Utilities/variables";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import { ProductModel, WishListLineModel } from "@insite/client-framework/Types/ApiModels";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    const location = getLocation(state);

    return {
        pageTitle: getCurrentPage(state).fields.title,
        location,
    };
};

interface OwnProps {
    item: ProductModel | WishListLineModel;
    extendedStyles?: SpecSheetStyles;
}

export interface SpecSheetStyles {
    specSheetButtonWrapper?: InjectableCss;
    specSheetButton?: ButtonPresentationProps;
}

export const specSheetStyles: SpecSheetStyles = {
    specSheetButtonWrapper: {
        css: css`
            padding-top: 10px;

            ${mediaQueriesBP.maxMD} {
                padding: 5px;
            }
        `,
    },

    specSheetButton: {
        variant: "secondary",
    },
};

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const SpecSheet = ({ item, extendedStyles, pageTitle }: Props) => {
    if (!item) {
        return null;
    }

    const [styles] = React.useState(() => mergeToNew(specSheetStyles, extendedStyles));
    const btnLabel = translate("Spec Sheet");

    /* Verndale Custom Feature - Add spec sheet feature */
    const handleSpecSheetClick = () => {
        let filePath = "";
        let fileExt = "";
        let fileName = "";

        if ("documents" in item && item.documents && item.documents.length > 0) {
            filePath = item.documents[0].filePath;
            fileExt = item.documents[0].documentType;
            fileName = item.documents[0].name;
        } else if (item?.properties?.specSheet) {
            filePath = item.properties.specSheet;
            fileExt = item.properties.specSheet.split(".").pop() || "";
            fileName = item.properties.modelNumber ?? "";
        }

        const currentLocation = window.location;

        setGA4Event([], "file_download", {
            file_name: fileName,
            file_extension: fileExt,
            link_text: btnLabel,
            link_url: currentLocation.href,
            pageTitle,
        });

        const redirectWindow = window.open(filePath, "_blank");
        redirectWindow?.location.reload();
    };

    return (
        <StyledWrapper {...styles.specSheetButtonWrapper}>
            <Button {...styles.specSheetButton} onClick={handleSpecSheetClick}>
                {btnLabel}
            </Button>
        </StyledWrapper>
    );
};

export default connect(mapStateToProps)(SpecSheet as any) as any;
